// Charge points
export const SET_CHARGEPOINTS = 'SET_CHARGEPOINTS';
export const SET_ALL_ORIGIN_CHARGEPOINTS = 'SET_ALL_ORIGIN_CHAGEPOINTS';
export const SET_PLUG_SHARE_CHARGEPOINTS = 'SET_PLUG_SHARE_CHARGEPOINTS';
export const SET_CHARGEPOINT_CONNECTOR = 'SET_CHARGEPOINT_CONNECTOR';
export const SET_CONNECTOR_TYPE = 'SET_CONNECTOR_TYPE';
export const SET_CHARGE_POINT = 'SET_CHARGE_POINT';

// Global Search System
export const INPUT_TYPE = 'INPUT_TYPE';
export const GET_SEARCH_RESULT = 'GET_SEARCH_RESULT';
export const CLEAN_SEARCH_RESULT = 'CLEAN_SEARCH_RESULT';
export const SELECT_OPTION_GLOBAL_SEARCH = 'SELECT_OPTION_GLOBAL_SEARCH';
export const SET_SEARCH_USER = 'SET_SEARCH_USER';
export const SET_SEARCH_TRANSACTION = 'SET_SEARCH_TRANSACTION';
export const SET_SEARCH_OPERATION = 'SET_SEARCH_OPERATION';

// User
export const SET_IS_USER_AUTHENTICATED = 'SET_IS_USER_AUTHENTICATED';
export const SET_ROUTES = 'SET_ROUTES';

// Notifications
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const ADD_FILTERED_NOTIFICATIONS = 'ADD_FILTERED_NOTIFICATIONS';
export const ADD_FILTERED_NOTIFICATION = 'ADD_FILTERED_NOTIFICATION';
export const ADD_FILTERED_USER_NOTIFICATIONS =
  'ADD_FILTERED_USER_NOTIFICATIONS';
export const ADD_FILTERED_USER_NOTIFICATION = 'ADD_FILTERED_USER_NOTIFICATION';

// Websocket
export const SET_WEBSOCKET_CLIENT = 'SET_WEBSOCKET_CLIENT';

// OcppTags
export const SET_OCPPTAGS = 'SET_OCPPTAGS';

// Vouchers
export const SET_USERS_VOUCHER_LIST = 'SET_USERS_VOUCHER_LIST';
export const SET_VOUCHER_FORM_VALUES = ' SET_VOUCHER_FORM_VALUES';

// Advanced Settings
export const SET_VIRTUAL_GROUP_FORM_VALUES = ' SET_VIRTUAL_GROUP_FORM_VALUES';
